/** Fired (no payload) after Atlas durably saved a routine; routines surfaces re-read the API (027.006). */
export const ROUTINES_CHANGED_EVENT = "command:routines-changed";
